import { rest } from 'msw';
import { SOCKET_ROOT } from 'configs/env-vars';
import { socketData } from '../mockData/socket-data';

const SocketApi = [rest.get(`${SOCKET_ROOT}socket.io`, (req, res, ctx) => res(ctx.json(socketData)))];

export default SocketApi;
